export const snapshotSortKeyMap = {
  BILLABLE_INCREASED_REVENUE: "billable_inc_rev_net_twd",
  NET_INCREASED_REVENUE: "g_inc_rev_net_twd",
  NET_HOLISTIC_INCREASED_REVENUE: "h_inc_rev_net_p_twd",
  TOTAL_HOLISTIC_REVENUE: "h_rev_wyb_t_twd",
};

export const snapshotSortKeyName = {
  BILLABLE_INCREASED_REVENUE: "Net Billable Increased Revenue",
  NET_INCREASED_REVENUE: "Net Google Increased Revenue",
  NET_HOLISTIC_INCREASED_REVENUE: "Net Programmatic Holistic Increased Revenue",
  TOTAL_HOLISTIC_REVENUE: "Total Holistic Revenue",
};

export const snapshotSortByDayKeyMap = {
  TODAY: "TODAY",
  D_1: "D_1",
  PAST_3_DAYS_AVG: "PAST_3_DAYS_AVG",
  PAST_7_DAYS_AVG: "PAST_7_DAYS_AVG",
};

export const SNAPSHOT_PRESETS = {
  BEST_EARNING_7D: "best_earning_7d",
  WORST_EARNING_D_1: "worst_earning_d_1",
};

export const SNAPSHOT_PRESET_CONFIGS = {
  [SNAPSHOT_PRESETS.BEST_EARNING_7D]: {
    label: "Best Earning 7D",
    selectedSortType: snapshotSortKeyMap.BILLABLE_INCREASED_REVENUE,
    selectedSortByDayType: snapshotSortByDayKeyMap.PAST_7_DAYS_AVG,
    isOrderByDesc: true,
  },
  [SNAPSHOT_PRESETS.WORST_EARNING_D_1]: {
    label: "Worst Earning D-1",
    selectedSortType: snapshotSortKeyMap.BILLABLE_INCREASED_REVENUE,
    selectedSortByDayType: snapshotSortByDayKeyMap.D_1,
    isOrderByDesc: false,
  },
};
